
export class PageViewInputDto {
    date: Date;
    route: string;
    userId: string;
}
